module.exports = __webpack_public_path__ + "close-white.svg?e872c8e1e58d3071e51e7a6bbc0a06ab";